"use client";

import { useRive } from "rive-react";
import { useImperativeHandle, forwardRef } from "react";

export type RivePlayerRef = {
  play: () => void;
  pause: () => void;
  restart: () => void;
};

type RivePlayerProps = {
  src: string;
  autoplay: boolean;
  animations?: string;
};

const RivePlayer = forwardRef<RivePlayerRef, RivePlayerProps>(
  ({ src, autoplay = true, animations = "" }, ref) => {
    const { rive, RiveComponent } = useRive({
      src,
      autoplay,
      animations: animations,
    });

    useImperativeHandle(ref, () => ({
      play: () => rive?.play(),
      pause: () => rive?.pause(),
      restart: () => {
        if (rive) {
          rive.pause(); // stops all animations
          rive.play(); // starts them again from beginning
        }
      },
    }));

    return <RiveComponent />;
  },
);

RivePlayer.displayName = "RivePlayer";

export default RivePlayer;
